import { Draft } from '@reduxjs/toolkit';

import { IManufacturerData } from '../../index';

function editFailure(draft: Draft<IManufacturerData>) {
  draft.edit.config.isLoading = false;
}

export default editFailure;
